import React, { useState } from "react";
import { componentStyles } from "./UserDrawerStyles";
import { Menu, Row } from "antd";
import items from "../../constants/constants";
import { useNavigate, useLocation } from "react-router-dom";
import './DrawerMenuStyle.css'
import SubscriptionRestrictionModal from "../subscriptionIOSRestrictionModal/SubscriptionIOSRestrictionModal";

const DrawerMenu = ({ onClose }) => {
  const [menuItems, setMenuItems] = useState(items.drawerMenuItems);
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showVersionPopup, setShowVersionPopup] = useState(false);
  const [subscriptionRestrictModalVisible, setSubscriptionRestrictModalVisible] = useState(false);

  const openVersionPopup = () => {
    setShowVersionPopup(true);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };
  const handleActiveItem = (key) => {
    const updatedMenuItems = menuItems.map((item) => ({
      ...item,
      active: item.key === key,
    }));
    setMenuItems(updatedMenuItems);
  };

  const logoutUser = () => {
    localStorage.removeItem("auth_token");
    navigate("/");
  };

  function handleSupport() {
    window.open("https://www.strategiadatasciences.com/all-you-need-to-know-about-my-friend/", "_blank");
  }

  function handleTerms() {
    showModal();
  }
  const handleItemClick = async (key, url) => {
    handleActiveItem(key);
    const currentUrl = window.location.pathname;
    const platform = localStorage.getItem('userPlatform');

    if (currentUrl != url) {
      if (key === "logout") {
        logoutUser();
      } else if (key === "sub" && platform === "ios") {
        setSubscriptionRestrictModalVisible(true); 
      } else {
        navigate(url, { state: { from: location } });
      }
    }
    else {
      onClose();
    }
  };

  const [hoveredMenuItem, setHoveredMenuItem] = useState(null);

  const handleModalCancel = () => {
    setSubscriptionRestrictModalVisible(false);
  };

  const handleReturnHome = () => {
    setSubscriptionRestrictModalVisible(false);
    navigate('/'); 
  };

  return (
    <div>
      <Menu
        mode="vertical"
        theme="light"
        selectable={false}
        style={{ marginTop: "20px" }}
      >
        {menuItems.map((item) => (
          <Menu.Item
            key={item.key}
            style={
              hoveredMenuItem === item.key || item.active
                ? componentStyles.hoverStyles
                : {}
            }
            onMouseEnter={() => setHoveredMenuItem(item.key)}
            onMouseLeave={() => setHoveredMenuItem(null)}
            onClick={() => handleItemClick(item.key, item.url)}
          >
            <Row align="middle">
              <img src={item.icon} alt="" style={componentStyles.imageStyling} />
              <span style={componentStyles.title}>{item.title}</span>
            </Row>
          </Menu.Item>
        ))}
      </Menu>
      
      <SubscriptionRestrictionModal
        visible={subscriptionRestrictModalVisible}
        onCancel={handleModalCancel}
        onReturnHome={handleReturnHome}
      />
      
      <div style={componentStyles.helpContainer}>
        <span onClick={handleSupport} style={componentStyles.help}>
          Help & Support
        </span>
      </div>
    </div>
  );
};

export default DrawerMenu;
